import { render, staticRenderFns } from "./DeleteResult.vue?vue&type=template&id=4cf5037a&scoped=true&"
import script from "./DeleteResult.vue?vue&type=script&lang=js&"
export * from "./DeleteResult.vue?vue&type=script&lang=js&"
import style0 from "./DeleteResult.vue?vue&type=style&index=0&id=4cf5037a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5037a",
  null
  
)

export default component.exports